"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiteralUtils = void 0;
const Hashing_1 = require("./Hashing");
class LiteralUtils {
    static getType(literal) {
        return literal.value['_type'];
    }
    static getClassName(literal) {
        return literal.value['_class'];
    }
    static getFields(literal) {
        return literal.value['_fields'];
    }
    static getFlags(literal) {
        return literal.value['_flags'];
    }
    static validateHash(literal) {
        return literal.hash === Hashing_1.Hashing.forValue(literal.value);
    }
}
exports.LiteralUtils = LiteralUtils;
//# sourceMappingURL=Literals.js.map